import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'index',
	component: () => import('../views/index.vue'),
	meta: { hidden: true,title:"HR校招助手"}
  },{
    path: '/login',
    name: 'login',
	component: () => import('../views/login/login.vue'),
  },
  {
    path: '/register',
    name: 'login',
  	component: () => import('../views/login/register.vue'),
  },{
    path: '/forget',
    name: 'login',
  	component: () => import('../views/login/forget.vue'),
  },{
    path: '/schment',
    name: '校招攻略',
	component: () => import('../views/schment.vue'),
  },{
    path: '/member',
    name: 'vip会员',
	component: () => import('../views/vipmember.vue'),
  },{
    path: '/dynamics',
    name: '行业动态',
	component: () => import('../views/dynamics.vue'),
  },{
    path: '/cooperat',
    name: '企业合作',
	component: () => import('../views/cooperat.vue'),
  },{
    path: '/about',
    name: '关于我们',
	component: () => import('../views/about.vue'),
  },{
    path: '/userInfo',
    name: '用户信息',
	component: () => import('../views/userInfo.vue'),
  },
 
]

const router = new VueRouter({
  routes
})

export default router
